import { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { TruckDocument } from '../../../app/models/Truck';
import useTruckDocumentService from '../../../app/services/hooks/useTruckDocumentService';
import GeneralDocumentForm from '../../../components/GeneralDocumentForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    truckId: number;
    typeDocument: string;
}

const TruckDocumentCreate = ({ onSaved, onCancel, onError, typeDocument, truckId }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [truckDocument, setTruckDocument] = useState<TruckDocument>({
        truck_id: truckId,
        document_id: parseInt(typeDocument),
        is_expire_date_indefinite: false
    });

    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingStoreTruckDocument, storeTruckDocument } = useTruckDocumentService();
    const store = () => {
        if (!truckDocument) return;
        if (showLoading) showLoading('loading', 'Guardando documento...');
        storeTruckDocument(truckDocument, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    // if (errorGetData !== '') {
    //     return <div>{errorGetData}</div>;
    // }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <GeneralDocumentForm
                        document={truckDocument}
                        setDocument={setTruckDocument}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreTruckDocument} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreTruckDocument} />
                </div>
            </div>
        </>
    );
};

export default TruckDocumentCreate;
